import React, { Fragment, useState, useEffect } from "react";
import { Card, Modal, Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import * as Yup from "yup";
import { Formik} from "formik";

const SemSettings = () => {
  const location = useLocation();
  const { getRequest, putRequest } = useRequests();

  const [settingsData, setSettingsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [AlertData, setAlertData] = useState({
    variant: '',
    message: '',
  });

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "enable" or "disable"
  const [selectedSetting, setSelectedSetting] = useState(null);
  const [currentEdit, setCurrentEdit] = useState({ sem_id: null, title: "", value: "" });

  // Reset alert messages after a timeout
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((prev) => ({ ...prev, variant: '', message: '' }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  // Fetch settings data
  const fetchSettings = async () => {
    const response = await getRequest("sem-settings");
    if (response && response.code === 200) {
      setSettingsData(response.data);
    } else {
      setAlertData({ variant: 'error', message: 'Failed to fetch settings' });
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchSettings();
    if (location.state?.message) {
      setAlertData({
        variant: location.state.status,
        message: location.state.message,
      });
      resetAlertData();
    }
  }, [location.state]);

  // Handle search
  const filteredSettings = settingsData.filter((setting) =>

    `${setting.platform_name} ${setting.link} ${setting.status}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Open modal for enable/disable or editing
  const handleOpenModal = async (setting, type) => {
    setSelectedSetting(setting);
    setModalType(type);
    if (type === "edit") {
      // Set the selected setting values for editing
      setCurrentEdit({
        sem_id: setting.sem_id,
        title: setting.platform_name,
        value: setting.link,
      });
    }
    setShowModal(true);
  };

  // Close modal
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedSetting(null);
    setModalType("");
    setCurrentEdit({ sem_id: null, title: "", value: "" });
  };

  // Update settings data after edit
  const handleUpdate = async (values) => {
    const jsonpar = JSON.stringify({
      title: values.title,
      value: values.value,
    });
  
    const response = await putRequest(`sem-edit/${currentEdit.sem_id}`, jsonpar);
    if (response && response.code === 200) {
      setSettingsData((prevData) =>
        prevData.map((item) =>
          item.sem_id === currentEdit.sem_id
              ? { ...item, platform_name: values.title, link: values.value } // Ensure full update
              : item
      )
      );
      setAlertData({ variant: 'success', message: 'Setting updated successfully!' });
    } else {
      setAlertData({ variant: 'error', message: 'Failed to update setting' });
    }
    resetAlertData();
    handleModalClose();
  };
  
  // Update status field (Enable/Disable)
  const handleStatusChange = async (setting, type) => {
    const newStatus = type === "enable" ? "Enable" : "Disable";
    const jsonpar = JSON.stringify({
        status: newStatus,
      })
    const response = await putRequest(`sem-status/${setting.sem_id}`, jsonpar);
    if (response && response.code === 200) {
      setSettingsData((prevData) =>
        prevData.map((item) =>
          item.sem_id === setting.sem_id ? { ...item, status: newStatus } : item
        )
      );
      setAlertData({ variant: 'success', message: `Setting ${newStatus}d successfully!` });
    } else {
      setAlertData({ variant: 'error', message: `Failed to ${newStatus} setting` });
    }
    resetAlertData();
    handleModalClose();
  };

    
  const columns = [
    {
      name: "Title",
      selector: (row) => row.platform_name,
      sortable: true,
      width: "200px",
      textTransform:"Capitalie",
    },
    {
      name: "URL",
      cell: (row) => (
        <Link to={row.link} target="_blank" className="text-primary text-decoration-underline">
          {row.link}
        </Link>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          onClick={() => handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")}
          className={`btn ${row.status === "Enable" ? "btn-success" : "btn-danger"} btn-xxs`}
        >
          {row.status}
        </button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <Button onClick={() => handleOpenModal(row, "edit")} className="btn btn-primary btn-xs sharp" title="Edit SEM">
          <i className="flaticon-381-edit-1"></i>
        </Button>
      ),
      center: true,
      width: "120px",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        textTransform: "Capitalize",
      },
      "&:nth-of-type(1)": {
      textTransform: "capitalize !important",
    }
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
       "&:nth-of-type(1)": {
      textTransform: "capitalize !important",
    }
      },
   
   
    },
    
  };


  return (
    <Fragment>
      <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
        <h2 className="text-black font-w600 mb-0">SEM Settings</h2>
        {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      </div>

      {/* <div className="mb-4 d-sm-flex d-block justify-content-end">
      <div style={{ position: "relative", width: "18rem" }}>
      <Form.Control
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: "18rem",
            fontSize: "18px",
            fontWeight: 500,
            borderRadius: "0.625rem",
            height: "3.2rem",
          }}
        />
        <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>
       
       </div>
      </div> */}

      <Card>
        <Card.Body>

          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
        (<DataTable
            columns={columns}
            data={filteredSettings}
            customStyles={customStyles}
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

      {/* Modal */}
     

            <Modal show={showModal} onHide={handleModalClose} centered>
                <Formik
                    initialValues={{
                    title: currentEdit.title || "",
                    value: currentEdit.value || "",
                    }}
                    enableReinitialize={true} // Updates initial values when modal content changes
                    validationSchema={
                    modalType === "edit"
                        ? Yup.object({
                            title: Yup.string().required("Title is required"),
                            value: Yup.string().url("Invalid URL").required("URL is required"),
                        })
                        : null // No validation for enable/disable modals
                    }
                    onSubmit={async (values, { setSubmitting }) => {
                    if (modalType === "edit") {
                        await handleUpdate(values);
                    } else if (modalType === "enable" || modalType === "disable") {
                        await handleStatusChange(selectedSetting, modalType);
                    }
                    setSubmitting(false);
                    handleModalClose();
                    }}
                >
                    {({ values, handleChange, handleSubmit, errors, touched, isSubmitting }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                        <Modal.Title>
                            {modalType === "edit"
                            ? "Edit SEM Setting"
                            : `${modalType === "enable" ? "Enable" : "Disable"} Setting`}
                        </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        {modalType === "edit" ? (
                            <>
                            <Form.Group className="mb-3">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                type="text"
                                name="title"
                                style={{
                                    textTransform:"capitalize"
                                }}
                                readOnly
                                value={values.title}
                                onChange={handleChange}
                                isInvalid={touched.title && !!errors.title}
                                />
                                <Form.Control.Feedback type="invalid">
                                {errors.title}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>URL</Form.Label>
                                <Form.Control
                                type="text"
                                name="value"
                                value={values.value}
                                onChange={handleChange}
                                isInvalid={touched.value && !!errors.value}
                                />
                                <Form.Control.Feedback type="invalid">
                                {errors.value}
                                </Form.Control.Feedback>
                            </Form.Group>
                            </>
                        ) : (
                            <p>Are you sure you want to {modalType} this setting?</p>
                        )}
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="light" onClick={handleModalClose} disabled={isSubmitting}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                            {isSubmitting
                            ? "Processing..."
                            : modalType === "edit"
                            ? "Update"
                            : modalType === "enable"
                            ? "Enable"
                            : "Disable"}
                        </Button>
                        </Modal.Footer>
                    </Form>
                    )}
                </Formik>
        </Modal>


    </Fragment>
  );
};

export default SemSettings;
